
import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { AngularFirestore } from '@angular/fire/firestore';
import { Observable, BehaviorSubject } from "rxjs";


@Injectable({
  providedIn: "root"
})

export class ProfileService {

  public profileStatus: BehaviorSubject<object> = new BehaviorSubject<object>({});
  public leadSearchArea: BehaviorSubject<object> = new BehaviorSubject<object>({});
  public projectSearchArea: BehaviorSubject<object> = new BehaviorSubject<object>({});
  public contactTypeTitle: BehaviorSubject<string> = new BehaviorSubject<string>("Contacts");
  public sendToProduction: BehaviorSubject<object> = new BehaviorSubject<object>({});
  public currentTab: BehaviorSubject<string> = new BehaviorSubject<string>("");
  public requestDelivery: BehaviorSubject<string> = new BehaviorSubject<string>("");

  noAuthHeader = { headers: new HttpHeaders({ "Content-Type": "application/json" }) };
  
  constructor(
    private http: HttpClient,
    private firestore : AngularFirestore
  ) {
     this.firestore.firestore.settings({experimentalForceLongPolling: true});
  }

  updateProfileStatus(profile){
    this.profileStatus.next(profile);
  }

  // lead search area status 
  updateLeadSearchArea(obj){
    this.leadSearchArea.next(obj);
  }

  // project search area status
  updateProjectSearchArea(obj){
    this.projectSearchArea.next(obj);
  }

  // update active tab...
  updateTab(tab){
    this.currentTab.next(tab);
  }


  // update contact tye lable
    // project search area status
    changeContactType(val){
      this.contactTypeTitle.next(val);
    }
    
    // Update send to production status
    changeSendToProduction(val){
      this.sendToProduction.next(val);
    }

    // request delivery
    updateRequestDelivery(val){
      this.requestDelivery.next(val);
    }
  
  //HttpMethods

  getProfileDetail(userId) { 
    return this.firestore.collection("contacts", ref => ref.where('user_id', '==', userId)).snapshotChanges();
  }
  // get Profile Photo
  getProfilePhoto(contactId) { 
    return this.firestore.collection("files", ref => ref.where('contact_id', '==', contactId).where('is_profile_photo', '==', "Yes")).snapshotChanges();
  }

  // update profile
  updateProfile(uid,data) {
    // return this.http.post("update_profile", data, this.noAuthHeader);
    return this.firestore.collection("contacts").doc(uid).update(data);
  }

  // create file document
  createFileDocument(data) {
    return this.firestore.collection("files").doc(data.id).set(data);
  }

  
}
